'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

function checkWebpSupport() {
    if (typeof window !== 'undefined') {
        var elem = document.createElement('canvas');
        if (!!(elem.getContext && elem.getContext('2d'))) {
            return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }
        return false;
    }
}
var canUseWebp = checkWebpSupport();

exports.canUseWebp = canUseWebp;
exports.checkWebpSupport = checkWebpSupport;
//# sourceMappingURL=canUseWebp.js.map
